import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { driverApi } from '../services/driverApi';
import { useDriverProfile } from './useDriverProfile';

interface CreateImpoundParams {
  dispatchId: string;
  driverId?: string;
  storageLot: string;
  status?: 'ACTIVE' | 'RELEASED';
}

export const useCreateImpound = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const queryClient = useQueryClient();
  const { data: driverProfile } = useDriverProfile();

  return useMutation({
    mutationFn: async (params: CreateImpoundParams) => {
      if (!driverProfile?.companyId) {
        throw new Error('Driver profile or company ID not available');
      }
      
      const token = await getAccessTokenSilently();
      driverApi.setAuthToken(token);
      
      return driverApi.createImpound({
        ...params,
        companyId: driverProfile.companyId
      });
    },
    onSuccess: (data) => {
      // Invalidate and refetch impounds to get updated data
      queryClient.invalidateQueries({ queryKey: ['driver-impounds'] });
      
      // Also invalidate the specific impound query that ImpoundScreen might use
      queryClient.invalidateQueries({ queryKey: ['driver-impound', data.id] });
      
      // Invalidate calls as the call status might have changed
      queryClient.invalidateQueries({ queryKey: ['driver-calls'] });
    },
    onError: (error) => {
      console.error('Failed to create impound:', error);
    },
  });
}; 